export default __webpack_public_path__ + "c80fd32e345005964f7429677822a6ae.png";